import PropTypes from 'prop-types';
import React from 'react';

import { getSpecInfo } from 'shared/character';

import WowIcon from './WowIcon';

const SpecIcon = ({ charClass, spec, ...props }) => {
  const specInfo = getSpecInfo(charClass, spec);

  if (!specInfo) {
    return null;
  }

  return (
    <WowIcon
      icon={specInfo.icon}
      border="1px solid gray"
      {...props}
    />
  );
};

SpecIcon.propTypes = {
  spec: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  charClass: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SpecIcon.defaultProps = {
  spec: null,
  charClass: null,
};

export default SpecIcon;
